import { EmptyState } from "@/components/feedback/empty-state";
import { formatInr } from "@/lib/format/inr";

export interface TopCategory {
  name: string;
  count: number;
  amount: number;
}

export interface TopCategoriesCardProps {
  data: TopCategory[];
  totalAmount: number;
}

const PALETTE = [
  "#34D399",
  "#7CA6FF",
  "#FBBF24",
  "#A78BFA",
  "#F472B6",
  "#F87171",
];

function pctOf(amount: number, total: number): number {
  if (total <= 0) return 0;
  return Math.round((amount / total) * 100);
}

export function TopCategoriesCard({ data, totalAmount }: TopCategoriesCardProps) {
  if (data.length === 0) {
    return <EmptyState title="No category spend recorded yet" />;
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex h-5 overflow-hidden rounded border border-fc-border">
        {data.map((cat, i) => (
          <div
            key={cat.name}
            data-testid="cat-seg"
            style={{
              width: `${pctOf(cat.amount, totalAmount)}%`,
              background: PALETTE[i % PALETTE.length],
            }}
          />
        ))}
      </div>

      <div className="flex flex-col gap-1.5">
        {data.map((cat, i) => (
          <div
            key={cat.name}
            className="grid grid-cols-[10px_1fr_auto_auto] items-center gap-2 text-xs"
          >
            <span
              className="h-2.5 w-2.5 rounded-sm"
              style={{ background: PALETTE[i % PALETTE.length] }}
            />
            <span className="text-fc-text-secondary">{cat.name}</span>
            <span className="font-mono text-[11px] text-fc-text-dim">
              {pctOf(cat.amount, totalAmount)}%
            </span>
            <span className="font-mono text-[12px] font-semibold text-fc-text">
              {formatInr(cat.amount)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
